module.exports = __webpack_public_path__ + "img/iceing.daa3e90e.svg";